import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Nav, NavItem, NavLink, TabContent, TabPane,Breadcrumb, BreadcrumbItem,Col,Row, Container} from "reactstrap";
import classnames from 'classnames';

import UserPanelMenu from "./../../components/user/UserPanelMenu";
import ProfileInfo from "./../../components/user/ProfileInfo";
import ChangePassword from "./../../components/user/ChangePassword";
import ChangeAvatar from "./../../components/user/ChangeAvatar";

export default class UsersProfile extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        return (
            <div className="pt-5 mt-5">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active> صفحه کاربری</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <UserPanelMenu activeElement="2"/>
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '1' })}
                                                onClick={() => { this.toggle('1'); }}
                                            >
                                                اطلاعات شخصی
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '2' })}
                                                onClick={() => { this.toggle('2'); }}
                                            >
                                                تغییر تصویر
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '3' })}
                                                onClick={() => { this.toggle('3'); }}
                                            >
                                                تغییر رمز ورود
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                                <div className="portlet-body p-3">
                                    <TabContent activeTab={this.state.activeTab}>
                                        <TabPane tabId="1">
                                            <ProfileInfo/>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <ChangeAvatar/>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <ChangePassword/>
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/user/UsersProfile.js